export default __webpack_public_path__ + "static/media/step4LightMode.30866819.svg";